import { SnippetsBanners, SnippetsTable } from 'modules/productAnalytics/snippets/components';
import { SnippetsContextProvider } from 'modules/productAnalytics/snippets/context';
import { SnippetsTableModes } from 'modules/productAnalytics/snippets/types';
import { withRouter } from 'react-router';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';
import { useFiltersContext, useTimeFiltersContext } from '../context';
import { useUrlParamsContext } from '../context/UrlParamsContext';
import { LayoutTemplate } from './LayoutTemplate';
import { StyledCampaignAnalyticsCard } from './Styled';

export const CA_SNIPPETS_EXPANSION_KEY = 'campaign-analytics-snippets';

export const Snippets = () => {
  const { campaignId } = useUrlParamsContext();
  const { variantId } = useFiltersContext();
  const { dateParams = {} } = useTimeFiltersContext();

  const { startTime: startDate, endTime: endDate } = dateParams;
  const templateId = variantId === 'default' ? undefined : parseInt(variantId as string, 10);

  return (
    <LayoutTemplate pageName="Snippets" canShowFPOBanner={false}>
      <SnippetsContextProvider
        mode={SnippetsTableModes.CampaignAnalytics}
        campaignIds={campaignId ? [campaignId] : []}
        templateIdOpt={templateId}
        startTime={startDate?.format()}
        endTime={endDate?.format()}
      >
        <ExpansionContextProvider
          localKey={CA_SNIPPETS_EXPANSION_KEY}
          initialMode={ExpandModes.collapse}
        >
          <SnippetsBanners />
          <StyledCampaignAnalyticsCard snippets>
            <SnippetsTable />
          </StyledCampaignAnalyticsCard>
        </ExpansionContextProvider>
      </SnippetsContextProvider>
    </LayoutTemplate>
  );
};

export default withRouter(Snippets);
